export enum LeadManagersDesignation {
  SalesUser = 'SalesUser',
  MarketingUser = 'MarketingUser',
  Administrator = 'Administrator',
  SalesManager = 'SalesManager',
}
